import { adoptRecommendations } from './util/adoptRecommendations';

export function dismissRecommendations({
  deps,
  scope,
  recommendationType,
  recommendations,
  isAll,
  channel,
}) {
  return adoptRecommendations({
    deps,
    scope,
    recommendations,
    isAll,
    UserAction: '2',
    recommendationType,
    channel,
  });
}
